import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Homepage',
    redirect: '/Homepage',
    // component: () => import('../components/Homepage.vue'),
  },
  // ---------- 首页(落地页导航) ----------
  {
    path: '/Homepage',
    // name: 'Homepage',
    component: () => import('../components/Homepage.vue'),
  },
  // ---------- SEO（抽奖/礼品卡）----------
  {
    path: '/Aboutyou',
    name: 'Aboutyou',
    component: () => import('../components/Aboutyou.vue'),
  },

  {
    path: '/Aboutyou2',
    name: 'Aboutyou2',
    component: () => import('../components/Aboutyou2.vue'),
  },

  {
    path: '/ALDI',
    name: 'ALDI',
    component: () => import('../components/ALDI.vue'),
  },

  {
    path: '/ALDI1',
    name: 'ALDI1',
    component: () => import('../components/ALDI1.vue'),
  },

  {
    path: '/ALDI2',
    name: 'ALDI2',
    component: () => import('../components/ALDI2.vue'),
  },
  {
    path: '/ALDI3',
    name: 'ALDI3',
    component: () => import('../components/ALDI3.vue'),
  },

  {
    path: '/Amazon',
    name: 'Amazon',
    component: () => import('../components/Amazon.vue'),
  },

  {
    path: '/Amazon1',
    name: 'Amazon1',
    component: () => import('../components/Amazon1.vue'),
  },

  {
    path: '/Amazon2',
    name: 'Amazon2',
    component: () => import('../components/Amazon2.vue'),
  },

  {
    path: '/Amazon3',
    name: 'Amazon3',
    component: () => import('../components/Amazon3.vue'),
  },

  {
    path: '/Amazon4',
    name: 'Amazon4',
    component: () => import('../components/Amazon4.vue'),
  },

  {
    path: '/Amazon5',
    name: 'Amazon5',
    component: () => import('../components/Amazon5.vue'),
  },

  {
    path: '/Amazon6',
    name: 'Amazon6',
    component: () => import('../components/Amazon6.vue'),
  },

  {
    path: '/Amazon7',
    name: 'Amazon7',
    component: () => import('../components/Amazon7.vue'),
  },

  {
    path: '/AppleProducts',
    name: 'AppleProducts',
    component: () => import('../components/AppleProducts.vue'),
  },

  {
    path: '/Adidas',
    name: 'Adidas',
    component: () => import('../components/Adidas.vue'),
  },

  {
    path: '/Adidas2',
    name: 'Adidas2',
    component: () => import('../components/Adidas2.vue'),
  },

  {
    path: '/Baby',
    name: 'Baby',
    component: () => import('../components/Baby.vue'),
  },

  {
    path: '/Biedronki',
    name: 'Biedronki',
    component: () => import('../components/Biedronki.vue'),
  },

  {
    path: '/Biedronki1',
    name: 'Biedronki1',
    component: () => import('../components/Biedronki1.vue'),
  },
  {
    path: '/BurgerKing',
    name: 'BurgerKing',
    component: () => import('../components/BurgerKing.vue'),
  },
  {
    path: '/BurgerKing2',
    name: 'BurgerKing2',
    component: () => import('../components/BurgerKing2.vue'),
  },
  // {
  //   path: '/CashApp',
  //   name: 'CashApp',
  //   component: () => import('../components/CashApp.vue'),
  // },

  // {
  //   path: '/CashApp1',
  //   name: 'CashApp1',
  //   component: () => import('../components/CashApp1.vue'),
  // },

  {
    path: '/CashApp2',
    name: 'CashApp2',
    component: () => import('../components/CashApp2.vue'),
  },

  // {
  //   path: '/CashApp3',
  //   name: 'CashApp3',
  //   component: () => import('../components/CashApp3.vue'),
  // },

  // {
  //   path: '/CashApp4',
  //   name: 'CashApp4',
  //   component: () => import('../components/CashApp4.vue'),
  // },
  // {
  //   path: '/CashApp5',
  //   name: 'CashApp5',
  //   component: () => import('../components/CashApp5.vue'),
  // },
  // {
  //   path: '/CashApp6',
  //   name: 'CashApp6',
  //   component: () => import('../components/CashApp6.vue'),
  // },
  // {
  //   path: '/CashApp7',
  //   name: 'CashApp7',
  //   component: () => import('../components/CashApp7.vue'),
  // },
  {
    path: '/CashApp9',
    name: 'CashApp9',
    component: () => import('../components/CashApp9.vue'),
  },
  {
    path: '/CashApp9_cf',
    name: 'CashApp9_cf',
    component: () => import('../components/CashApp9_cf.vue'),
  },
  {
    path: '/CashApp10',
    name: 'CashApp10',
    component: () => import('../components/CashApp10.vue'),
  },
  {
    path: '/CashApp10_cf',
    name: 'CashApp10_cf',
    component: () => import('../components/CashApp10_cf.vue'),
  },
  {
    path: '/CashApp11',
    name: 'CashApp11',
    component: () => import('../components/CashApp11.vue'),
  },
  {
    path: '/CashApp11_cf',
    name: 'CashApp11_cf',
    component: () => import('../components/CashApp11_cf.vue'),
  },
  // {
  //   path: '/CashApp8',
  //   name: 'CashApp8',
  //   component: () => import('../components/CashApp8.vue'),
  // },
  {
    path: '/Christmas',
    name: 'Christmas',
    component: () => import('../components/Christmas.vue'),
  },

  {
    path: '/Clarks',
    name: 'Clarks',
    component: () => import('../components/Clarks.vue'),
  },

  {
    path: '/Costco',
    name: 'Costco',
    component: () => import('../components/Costco.vue'),
  },

  {
    path: '/Costco1',
    name: 'Costco1',
    component: () => import('../components/Costco1.vue'),
  },

  {
    path: '/Costco2',
    name: 'Costco2',
    component: () => import('../components/Costco2.vue'),
  },

  {
    path: '/cocaPage',
    name: 'cocaPage',
    component: () => import('../components/cocaPage.vue'),
  },

  {
    path: '/deAmazon',
    name: 'deAmazon',
    component: () => import('../components/deAmazon.vue'),
  },

  {
    path: '/Ebike',
    name: 'Ebike',
    component: () => import('../components/Ebike.vue'),
  },

  {
    path: '/Elektronisk',
    name: 'Elektronisk',
    component: () => import('../components/Elektronisk.vue'),
  },

  {
    path: '/Groceries',
    name: 'Groceries',
    component: () => import('../components/Groceries.vue'),
  },

  {
    path: '/Halloween',
    name: 'Halloween',
    component: () => import('../components/Halloween.vue'),
  },

  {
    path: '/Hemkop',
    name: 'Hemkop',
    component: () => import('../components/Hemkop.vue'),
  },

  {
    path: '/IGA',
    name: 'IGA',
    component: () => import('../components/IGA.vue'),
  },

  {
    path: '/Iphone17',
    name: 'Iphone17',
    component: () => import('../components/Iphone17.vue'),
  },

  {
    path: '/McDonalds',
    name: 'McDonalds',
    component: () => import('../components/McDonalds.vue'),
  },
  {
    path: '/McDonalds2',
    name: 'McDonalds2',
    component: () => import('../components/McDonalds2.vue'),
  },
  {
    path: '/Outback',
    name: 'Outback',
    component: () => import('../components/Outback.vue'),
  },
  {
    path: '/Publix',
    name: 'Publix',
    component: () => import('../components/Publix.vue'),
  },

  {
    path: '/popmart',
    name: 'popmart',
    component: () => import('../components/popmart.vue'),
  },

  {
    path: '/PaknSave',
    name: 'PaknSave',
    component: () => import('../components/PaknSave.vue'),
  },

  {
    path: '/Presentkort',
    name: 'Presentkort',
    component: () => import('../components/Presentkort.vue'),
  },
  {
    path: '/Paypal',
    name: 'Paypal',
    component: () => import('../components/Paypal.vue'),
  },

  {
    path: '/Shopee',
    name: 'Shopee',
    component: () => import('../components/Shopee.vue'),
  },
  {
    path: '/Shein',
    name: 'Shein',
    component: () => import('../components/Shein.vue'),
  },

  {
    path: '/SoftDrink',
    name: 'SoftDrink',
    component: () => import('../components/SoftDrink.vue'),
  },
  {
    path: '/SamsungS10',
    name: 'SamsungS10',
    component: () => import('../components/SamsungS10.vue'),
  },

  {
    path: '/Subway',
    name: 'Subway',
    component: () => import('../components/Subway.vue'),
  },
  {
    path: '/Subway2',
    name: 'Subway2',
    component: () => import('../components/Subway2.vue'),
  },
  {
    path: '/Subway3',
    name: 'Subway3',
    component: () => import('../components/Subway3.vue'),
  },
  {
    path: '/Target',
    name: 'Target',
    component: () => import('../components/Target.vue'),
  },

  {
    path: '/Target1',
    name: 'Target1',
    component: () => import('../components/Target1.vue'),
  },

  {
    path: '/Uniqlo',
    name: 'Uniqlo',
    component: () => import('../components/Uniqlo.vue'),
  },

  {
    path: '/Willys',
    name: 'Willys',
    component: () => import('../components/Willys.vue'),
  },

  {
    path: '/iphone',
    name: 'iphone',
    component: () => import('../components/iphone.vue'),
  },

  {
    path: '/iphone3',
    name: 'iphone3',
    component: () => import('../components/iphone3.vue'),
  },
  {
    path: '/Kroger',
    name: 'Kroger',
    component: () => import('../components/Kroger.vue'),
  },
  {
    path: '/Kroger2',
    name: 'Kroger2',
    component: () => import('../components/Kroger2.vue'),
  },
  {
    path: '/Laundry',
    name: 'Laundry',
    component: () => import('../components/Laundry.vue'),
  },

  {
    path: '/Mac',
    name: 'Mac',
    component: () => import('../components/Mac.vue'),
  },
  {
    path: '/MacBook',
    name: 'MacBook',
    component: () => import('../components/MacBook.vue'),
  },
  {
    path: '/MacBook2',
    name: 'MacBook2',
    component: () => import('../components/MacBook2.vue'),
  },

  {
    path: '/Markita',
    name: 'Markita',
    component: () => import('../components/Markita.vue'),
  },

  {
    path: '/Markt',
    name: 'Markt',
    component: () => import('../components/Markt.vue'),
  },

  {
    path: '/MyDailySurge',
    name: 'MyDailySurge',
    component: () => import('../components/MyDailySurge.vue'),
  },

  {
    path: '/newbike',
    name: 'newbike',
    component: () => import('../components/newbike.vue'),
  },

  {
    path: '/nutella',
    name: 'nutella',
    component: () => import('../components/nutella.vue'),
  },

  {
    path: '/nutella1',
    name: 'nutella1',
    component: () => import('../components/nutella1.vue'),
  },

  {
    path: '/nutella2',
    name: 'nutella2',
    component: () => import('../components/nutella2.vue'),
  },

  {
    path: '/walmart',
    name: 'walmart',
    component: () => import('../components/walmart.vue'),
  },

  {
    path: '/walmart1',
    name: 'walmart1',
    component: () => import('../components/walmart1.vue'),
  },

  {
    path: '/walmart2',
    name: 'walmart2',
    component: () => import('../components/walmart2.vue'),
  },

  {
    path: '/walmart3',
    name: 'walmart3',
    component: () => import('../components/walmart3.vue'),
  },

  {
    path: '/walmart4',
    name: 'walmart4',
    component: () => import('../components/walmart4.vue'),
  },

  {
    path: '/walmart5',
    name: 'walmart5',
    component: () => import('../components/walmart5.vue'),
  },

  {
    path: '/walmart6',
    name: 'walmart6',
    component: () => import('../components/Walmart6.vue'),
  },

  {
    path: '/walmart7',
    name: 'walmart7',
    component: () => import('../components/Walmart7.vue'),
  },

  {
    path: '/walmart8',
    name: 'walmart8',
    component: () => import('../components/Walmart8.vue'),
  },
  {
    path: '/walmart9',
    name: 'walmart9',
    component: () => import('../components/Walmart9.vue'),
  },
  {
    path: '/walmart10',
    name: 'walmart10',
    component: () => import('../components/Walmart10.vue'),
  },
  {
    path: '/Walmart11',
    name: 'Walmart11',
    component: () => import('../components/Walmart11.vue'),
  },
  {
    path: '/walmarttime',
    name: 'walmarttime',
    component: () => import('../components/walmarttime.vue'),
  },

  {
    path: '/General',
    name: 'General',
    component: () => import('../components/General.vue'),
  },
  {
    path: '/testcf',
    name: 'testcf',
    component: () => import('../components/testcf.vue'),
  },

  //
  //
  //
  //
  //
  // ---------- Nutrition（营养品/药物）----------
  {
    path: '/Abslim',
    name: 'Abslim',
    component: () => import('../components/Abslim.vue'),
  },

  {
    path: '/Apaizia',
    name: 'Apaizia',
    component: () => import('../components/Apaizia.vue'),
  },

  {
    path: '/Artizynt',
    name: 'Artizynt',
    component: () => import('../components/Artizynt.vue'),
  },

  {
    path: '/Artizynt2',
    name: 'Artizynt2',
    component: () => import('../components/Artizynt2.vue'),
  },

  {
    path: '/ArtroFlex2',
    name: 'ArtroFlex2',
    component: () => import('../components/ArtroFlex2.vue'),
  },

  {
    path: '/Artroflex',
    name: 'Artroflex',
    component: () => import('../components/Artroflex.vue'),
  },

  {
    path: '/Artronol',
    name: 'Artronol',
    component: () => import('../components/Artronol.vue'),
  },

  {
    path: '/Artronol2',
    name: 'Artronol2',
    component: () => import('../components/Artronol2.vue'),
  },

  {
    path: '/Arthrovia',
    name: 'Arthrovia',
    component: () => import('../components/Arthrovia.vue'),
  },

  {
    path: '/Balancio',
    name: 'Balancio',
    component: () => import('../components/Balancio.vue'),
  },

  {
    path: '/Balancio2',
    name: 'Balancio2',
    component: () => import('../components/Balancio2.vue'),
  },

  {
    path: '/Balancio3',
    name: 'Balancio3',
    component: () => import('../components/Balancio3.vue'),
  },

  {
    path: '/Bick',
    name: 'Bick',
    component: () => import('../components/Bick.vue'),
  },
  // {
  //   path: '/Biovancia',
  //   name: 'Biovancia',
  //   component: () => import('../components/Biovancia.vue'),
  // },
  {
    path: '/Biovancia2',
    name: 'Biovancia2',
    component: () => import('../components/Biovancia2.vue'),
  },

  {
    path: '/calm',
    name: 'Calm',
    component: () => import('../components/Calm.vue'),
  },

  {
    path: '/calm1',
    name: 'Calm1',
    component: () => import('../components/Calm1.vue'),
  },

  {
    path: '/calm2',
    name: 'Calm2',
    component: () => import('../components/Calm2.vue'),
  },

  {
    path: '/CardioGenix',
    name: 'CardioGenix',
    component: () => import('../components/CardioGenix.vue'),
  },

  {
    path: '/CardioGenix2',
    name: 'CardioGenix2',
    component: () => import('../components/CardioGenix2.vue'),
  },

  {
    path: '/CardioGenix3',
    name: 'CardioGenix3',
    component: () => import('../components/CardioGenix3.vue'),
  },

  {
    path: '/Cardiotens',
    name: 'Cardiotens',
    component: () => import('../components/Cardiotens.vue'),
  },

  {
    path: '/Cardiotens2',
    name: 'Cardiotens2',
    component: () => import('../components/Cardiotens2.vue'),
  },

  {
    path: '/Collacare',
    name: 'Collacare',
    component: () => import('../components/Collacare.vue'),
  },

  {
    path: '/Cystonette',
    name: 'Cystonette',
    component: () => import('../components/Cystonette.vue'),
  },

  {
    path: '/Desparazil',
    name: 'Desparazil',
    component: () => import('../components/Desparazil.vue'),
  },

  {
    path: '/Desparazil2',
    name: 'Desparazil2',
    component: () => import('../components/Desparazil2.vue'),
  },

  {
    path: '/Diaformrx',
    name: 'Diaformrx',
    component: () => import('../components/Diaformrx.vue'),
  },

  {
    path: '/Dianol',
    name: 'Dianol',
    component: () => import('../components/Dianol.vue'),
  },

  {
    path: '/Diofin',
    name: 'Diofin',
    component: () => import('../components/Diofin.vue'),
  },

  {
    path: '/EarlickForte',
    name: 'EarlickForte',
    component: () => import('../components/EarlickForte.vue'),
  },

  {
    path: '/Fleboxin',
    name: 'Fleboxin',
    component: () => import('../components/Fleboxin.vue'),
  },

  {
    path: '/Flexosamine',
    name: 'Flexosamine',
    component: () => import('../components/Flexosamine.vue'),
  },

  {
    path: '/Flexosamine2',
    name: 'Flexosamine2',
    component: () => import('../components/Flexosamine2.vue'),
  },

  {
    path: '/Flexosamine3',
    name: 'Flexosamine3',
    component: () => import('../components/Flexosamine3.vue'),
  },

  {
    path: '/FungoKiller',
    name: 'FungoKiller',
    component: () => import('../components/FungoKiller.vue'),
  },

  {
    path: '/GLPPatch',
    name: 'GLPPatch',
    component: () => import('../components/GLPPatch.vue'),
  },

  {
    path: '/Glucavit',
    name: 'Glucavit',
    component: () => import('../components/Glucavit.vue'),
  },

  {
    path: '/Hairflex',
    name: 'Hairflex',
    component: () => import('../components/Hairflex.vue'),
  },

  {
    path: '/Health',
    name: 'Health',
    component: () => import('../components/Health.vue'),
  },

  {
    path: '/Herbolo',
    name: 'Herbolo',
    component: () => import('../components/Herbolo.vue'),
  },

  {
    path: '/Hondro',
    name: 'Hondro',
    component: () => import('../components/Hondro.vue'),
  },

  {
    path: '/HondroLife',
    name: 'HondroLife',
    component: () => import('../components/HondroLife.vue'),
  },

  {
    path: '/idealfit',
    name: 'idealfit',
    component: () => import('../components/idealfit.vue'),
  },

  {
    path: '/Idealfit2',
    name: 'Idealfit2',
    component: () => import('../components/Idealfit2.vue'),
  },

  {
    path: '/Ketonic',
    name: 'Ketonic',
    component: () => import('../components/Ketonic.vue'),
  },

  {
    path: '/KetoPlus',
    name: 'KetoPlus',
    component: () => import('../components/KetoPlus.vue'),
  },
  {
    path: '/Keranique',
    name: 'Keranique',
    component: () => import('../components/Keranique.vue'),
  },

  {
    path: '/Lacrea',
    name: 'Lacrea',
    component: () => import('../components/Lacrea.vue'),
  },

  {
    path: '/Lacrea2',
    name: 'Lacrea2',
    component: () => import('../components/Lacrea2.vue'),
  },

  {
    path: '/Noom',
    name: 'Noom',
    component: () => import('../components/Noom.vue'),
  },

  {
    path: '/Nutrilaben',
    name: 'Nutrilaben',
    component: () => import('../components/Nutrilaben.vue'),
  },

  {
    path: '/Optipills',
    name: 'Optipills',
    component: () => import('../components/Optipills.vue'),
  },

  {
    path: '/Osteon',
    name: 'Osteon',
    component: () => import('../components/Osteon.vue'),
  },

  {
    path: '/Osteomeo',
    name: 'Osteomeo',
    component: () => import('../components/Osteomeo.vue'),
  },

  {
    path: '/PAINRELIEFCream',
    name: 'PAINRELIEFCream',
    component: () => import('../components/PAINRELIEFCream.vue'),
  },

  {
    path: '/Predstonorm',
    name: 'Predstonorm',
    component: () => import('../components/Predstonorm.vue'),
  },

  {
    path: '/Prostalis',
    name: 'Prostalis',
    component: () => import('../components/Prostalis.vue'),
  },

  {
    path: '/Retoxin',
    name: 'Retoxin',
    component: () => import('../components/Retoxin.vue'),
  },
  {
    path: '/Semaglutide',
    name: 'Semaglutide',
    component: () => import('../components/Semaglutide.vue'),
  },
  {
    path: '/Slimmatica',
    name: 'Slimmatica',
    component: () => import('../components/Slimmatica.vue'),
  },

  {
    path: '/TestoLink',
    name: 'TestoLink',
    component: () => import('../components/TestoLink.vue'),
  },

  {
    path: '/Transplant',
    name: 'Transplant',
    component: () => import('../components/Transplant.vue'),
  },

  {
    path: '/Vidalyn',
    name: 'Vidalyn',
    component: () => import('../components/Vidalyn.vue'),
  },

  {
    path: '/VistaFocus',
    name: 'VistaFocus',
    component: () => import('../components/VistaFocus.vue'),
  },
  //
  //
  //
  //
  //
  // ---------- 电商 ----------
  {
    path: '/Akko',
    name: 'Akko',
    component: () => import('../components/Akko.vue'),
  },

  {
    path: '/Barkwave',
    name: 'Barkwave',
    component: () => import('../components/Barkwave.vue'),
  },

  {
    path: '/Christiancafe',
    name: 'Christiancafe',
    component: () => import('../components/Christiancafe.vue'),
  },

  {
    path: '/Dreamzy',
    name: 'Dreamzy',
    component: () => import('../components/Dreamzy.vue'),
  },

  {
    path: '/Listicle',
    name: 'Listicle',
    component: () => import('../components/Listicle.vue'),
    children: [
      {
        path: 'Datenschutz',
        name: 'Datenschutz',
        component: () => import('../common/Datenschutz.vue'),
      },
      {
        path: 'Bedingungen',
        name: 'Bedingungen',
        component: () => import('../common/Bedingungen.vue'),
      },
    ],
  },

  {
    path: '/Listicle2',
    name: 'Listicle2',
    component: () => import('../components/Listicle2.vue'),
    children: [
      {
        path: 'Datenschutz',
        name: 'Datenschutz2',
        component: () => import('../common/Datenschutz.vue'),
      },
      {
        path: 'Bedingungen',
        name: 'Bedingungen2',
        component: () => import('../common/Bedingungen.vue'),
      },
    ],
  },

  {
    path: '/Listicle3',
    name: 'Listicle3',
    component: () => import('../components/Listicle3.vue'),
    children: [
      {
        path: 'Datenschutz',
        name: 'Datenschutz',
        component: () => import('../common/Datenschutz.vue'),
      },
      {
        path: 'Bedingungen',
        name: 'Bedingungen',
        component: () => import('../common/Bedingungen.vue'),
      },
    ],
  },

  {
    path: '/LizBuys',
    name: 'LizBuys',
    component: () => import('../components/LizBuys.vue'),
  },

  {
    path: '/Lulutx',
    name: 'Lulutx',
    component: () => import('../components/Lulutx.vue'),
  },

  {
    path: '/Matsato',
    name: 'Matsato',
    component: () => import('../components/Matsato.vue'),
  },

  {
    path: '/Moving',
    name: 'Moving',
    component: () => import('../components/Moving.vue'),
  },

  {
    path: '/Nuubu1',
    name: 'Nuubu1',
    component: () => import('../components/Nuubu1.vue'),
  },

  {
    path: '/Property1',
    name: 'Property1',
    component: () => import('../components/Property1.vue'),
  },

  {
    path: '/RetroPocket',
    name: 'RetroPocket',
    component: () => import('../components/RetroPocket.vue'),
  },

  {
    path: '/Ryoko1',
    name: 'Ryoko1',
    component: () => import('../components/Ryoko1.vue'),
  },
  {
    path: '/Soulmatesequence',
    name: 'Soulmatesequence',
    component: () => import('../components/Soulmatesequence.vue'),
  },
  {
    path: '/ShoulderHealth',
    name: 'ShoulderHealth',
    component: () => import('../components/ShoulderHealth.vue'),
  },
  {
    path: '/Trends',
    name: 'Trends',
    component: () => import('../components/Trends.vue'),
  },

  {
    path: '/derila',
    name: 'derila',
    component: () => import('../components/derila.vue'),
  },
  //
  //
  //
  //
  //
  // ---------- 保险/家装 ----------
  {
    path: '/bathroom',
    name: 'Bathroom',
    component: () => import('../components/BathroomProject.vue'),
  },

  {
    path: '/BathroomLandingPage',
    name: 'BathroomLandingPage',
    component: () => import('../components/BathroomLandingPage.vue'),
  },

  {
    path: '/Bathpros',
    name: 'Bathpros',
    component: () => import('../components/Bathpros.vue'),
  },

  {
    path: '/Gutter',
    name: 'Gutter',
    component: () => import('../components/sewer.vue'),
  },

  {
    path: '/HVAC',
    name: 'HVAC',
    component: () => import('../components/HVAC.vue'),
  },

  {
    path: '/Homefix',
    name: 'Homefix',
    component: () => import('../components/Homefix.vue'),
  },

  {
    path: '/kitchen',
    name: 'Kitchen',
    component: () => import('../components/KitchenProject.vue'),
  },

  {
    path: '/NaturaLawn',
    name: 'NaturaLawn',
    component: () => import('../components/NaturaLawn.vue'),
  },

  {
    path: '/Policyproviders',
    name: 'Policyproviders',
    component: () => import('../components/Policyproviders.vue'),
  },

  {
    //   // 这个路由指向我们的重定向组件
    path: '/SolarQuoteLandingPage',
    name: 'SolarQuoteLandingPage', // 这个名字可以是任何你喜欢的
    component: () => import('../components/SolarQuoteLandingPage.vue'), // <--- 这里指向重定向组件
  },

  {
    path: '/SolarQuotePage',
    name: 'SolarQuotePage',
    component: () => import('../components/SolarQuotePage.vue'),
  },

  {
    path: '/VisitorsCov',
    name: 'VisitorsCov',
    component: () => import('../components/VisitorsCov.vue'),
  },

  {
    path: '/Walkin',
    name: 'Walkin',
    component: () => import('../components/Walkin.vue'),
  },

  {
    path: '/window',
    name: 'Window',
    component: () => import('../components/WindowProject.vue'),
  },

  {
    path: '/Window1',
    name: 'Window1',
    component: () => import('../components/Window1.vue'),
  },

  {
    path: '/Window2',
    name: 'Window2',
    component: () => import('../components/Window2.vue'),
  },

  {
    path: '/Window3',
    name: 'Window3',
    component: () => import('../components/Window3.vue'),
  },

  {
    path: '/Window4',
    name: 'Window4',
    component: () => import('../components/Window4.vue'),
  },

  {
    path: '/Window5',
    name: 'Window5',
    component: () => import('../components/Window5.vue'),
  },

  {
    path: '/YourHomes',
    name: 'YourHomes',
    component: () => import('../components/YourHomes.vue'),
  },

  {
    path: '/Yourinsurance',
    name: 'Yourinsurance',
    component: () => import('../components/Yourinsurance.vue'),
  },

  {
    path: '/avbathroom',
    name: 'avBathroom',
    component: () => import('../components/avBathroom.vue'),
  },

  {
    path: '/insurance',
    name: 'insurance',
    component: () => import('../components/insurance.vue'),
  },

  {
    path: '/petinsurance',
    name: 'petinsurance',
    component: () => import('../components/petinsurance.vue'),
  },

  {
    path: '/property',
    name: 'property',
    component: () => import('../components/property.vue'),
  },

  {
    path: '/roof',
    name: 'roof',
    component: () => import('../components/Homeowners.vue'),
  },

  {
    path: '/solar',
    name: 'solar',
    component: () => import('../components/solar.vue'),
  },
  //
  //
  //
  //
  //
  // ---------- 贷款 ----------
  {
    path: '/BestMoney',
    name: 'BestMoney',
    component: () => import('../components/BestMoney.vue'),
  },

  {
    path: '/Easyloan',
    name: 'Easyloan',
    component: () => import('../components/Easyloan.vue'),
  },
  // {
  //   path: '/loan',
  //   name: 'Loan',
  //   component: () => import('../components/Loan.vue'),
  // },

  // {
  //   path: '/loan2',
  //   name: 'Loan2',
  //   component: () => import('../components/Loan2.vue'),
  // },
  {
    path: '/loan1',
    name: 'Loan1',
    component: () => import('../components/Loan1.vue'),
  },

  {
    path: '/MyAutoLoan',
    name: 'MyAutoLoan',
    component: () => import('../components/MyAutoLoan.vue'),
  },

  {
    path: '/RedArrowLoans',
    name: 'RedArrowLoans',
    component: () => import('../components/RedArrowLoans.vue'),
  },

  {
    path: '/FreddieMacLoan',
    name: 'FreddieMacLoan',
    component: () => import('../components/FreddieMacLoan.vue'),
  },
  // ---------- 其他（未在 Homepage 分类）----------
  {
    path: '/TTincident',
    name: 'TTincident',
    component: () => import('../components/TTincident.vue'),
  },
  {
    path: '/FBincident',
    name: 'FBincident',
    component: () => import('../components/FBincident.vue'),
  },
  // ---------- 404 ----------
  {
    path: '*', // 捕获所有未知路由
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "not-found" */ '../components/404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history', // 或 'hash'
  routes,
});

export default router;
